import { execOnLoad, formatPrice } from '../../scripts/helpers';
import './product-page.scss';
import Swiper from 'swiper';
import { Navigation, Scrollbar, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import breakpoints from '../../../.bundler/breakpoints.json';
import { initProductForm } from '../../scripts/components/product';
import { openMinicart } from '../../scripts/components/minicart';
import { getOmnibus } from '../../scripts/services/omnibus';
import { throttle } from 'lodash';
import {
  addToWishlist,
  deleteFromWishlist,
  getWishlist,
} from '../../scripts/components/wishlist';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const addToCartStickyButton = sectionContainer.querySelector(
    '.product-page__actions__sticky',
  );
  const addToCartButton = sectionContainer.querySelector(
    '.product-page__actions',
  );

  setTimeout(() => {
    if (addToCartButton.querySelector('.klaviyo-bis-trigger')) {
      const klaviyo = addToCartButton
        .querySelector('.klaviyo-bis-trigger')
        .cloneNode(true);
      addToCartStickyButton.appendChild(klaviyo);
      addToCartStickyButton.querySelector('.btn').style.display = 'none';
    }
  }, 1);

  const scrollCallback = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        addToCartStickyButton.classList.remove('shown');
        addToCartButton.classList.add('shown');
      } else {
        addToCartStickyButton.classList.add('shown');
        addToCartButton.classList.remove('shown');
      }
    });
  });

  scrollCallback.observe(addToCartButton);
  scrollCallback.observe(document.querySelector('.footer__section'));


  const wishlistButton = sectionContainer.querySelector('[data-wishlist-btn]');
  const gallery = sectionContainer.querySelector(
    '.product-page__gallery-medias',
  );
  if (gallery) {
    const icons = window?.dAgency?.icons;
    const lightbox = new PhotoSwipeLightbox({
      gallery: gallery,
      children: '.product-page__gallery-slide--image',
      pswpModule: PhotoSwipe,
      mainClass: 'pswp--custom',
      arrowPrev: true,
      arrowNext: true,
      zoom: false,
      close: true,
      counter: false,
      bgOpacity: 1,
      showHideAnimationType: 'fade',
      ...(icons
        ? {
            ...(icons.chevronLeft && icons.chevronRight
              ? {
                  arrowPrevSVG: icons.chevronLeft,
                  arrowNextSVG: icons.chevronRight,
                }
              : {}),
            ...(icons.close ? { closeSVG: icons.close } : {}),
          }
        : {}),
    });
    lightbox.init();

    const scrollbar = sectionContainer.querySelector(
      '.product-page__gallery-scrollbar',
    );
    const options = {
      loop: true,
      slidesPerView: 1,
      breakpoints: {
        [parseInt(breakpoints.lg.replace('px', ''))]: {
          slidesPerView: 3,
        },
      },
      modules: [
        ...(scrollbar ? [Scrollbar] : []),
      ],
      ...(scrollbar ? { scrollbar: { el: scrollbar, draggable: true } } : {}),
    };

    if (gallery.dataset.desktopMode != 'carousel') {
      var swiperGallery;
      const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
      const handleSwiper = () => {
        if (lgUp.matches) {
          if (swiperGallery && swiperGallery.destroy)
            swiperGallery.destroy(true, true);
        } else {
          swiperGallery = new Swiper(gallery, options);
        }
      };
      handleSwiper();
      lgUp.addEventListener('change', handleSwiper);
    } else {
      const swiperGallery = new Swiper(gallery, options);
      const thumbnails = sectionContainer.querySelectorAll(
        '.product-page__gallery-thumbnails-item[data-index]',
      );
      if (thumbnails.length > 0) {
        thumbnails.forEach((thumbnail) =>
          thumbnail.addEventListener('click', () =>
            swiperGallery.slideToLoop(thumbnail.dataset.index),
          ),
        );
        swiperGallery.on('realIndexChange', () =>
          thumbnails.forEach(
            (thumbnail) =>
              (thumbnail.dataset.active =
                thumbnail.dataset.index == swiperGallery.realIndex),
          ),
        );
      }
    }
  }

  const form = sectionContainer.querySelector('.product-page__form');
  if (form) {
    const submit = form.querySelector('[type="submit"]');
    const errorWrapper = form.querySelector('.product-page__error-wrapper');
    const errorMessage = form.querySelector(
      '.product-page__error [data-message]',
    );
    const updateUrl = (variantId) => {
      const search = window.location.search
        .replace(/^\?/, '')
        .split('&')
        .reduce(
          (args, curr) => (/^variant=/.test(curr) ? args : [...args, curr]),
          [`variant=${variantId}`],
        )
        .filter((arg) => !!arg)
        .join('&');
      history.replaceState(null, '', `${window.location.pathname}?${search}`);
    };
    const updateOptions = ({ variant: selectedVariant, product }) => {
      const options = selectedVariant.options.reduce(
        (acc, option, index) => ({ ...acc, [`option${index + 1}`]: option }),
        {},
      );

      sectionContainer
        .querySelectorAll('.product-page__option-value input')
        .forEach((input) => {
          const currentOptions = { ...options, [input.name]: input.value };
          const foundVariant = product.variants.find((variant) =>
            Object.keys(currentOptions).every(
              (optionName) => variant[optionName] == currentOptions[optionName],
            ),
          );
          input.disabled =
            !input.checked && foundVariant && !foundVariant?.available;
        });
    };

    const omnibusContainer = sectionContainer.querySelector(
      '.omnibus__container[data-sku][data-variant-price]',
    );
    const omnibusValue = sectionContainer.querySelector(
      '.omnibus__container [data-omnibus-value]',
    );
    const updateOmnibus = () => {
      if ((omnibusContainer, omnibusValue))
        getOmnibus({
          sku: omnibusContainer.dataset.sku,
          callbacks: {
            afterFetch: (omnibus) => {
              if (omnibus?.price) {
                if (
                  omnibus.price * 100 !==
                  parseInt(omnibusContainer.dataset.variantPrice)
                ) {
                  omnibusValue.innerHTML = formatPrice({
                    value: omnibus.price * 100,
                  });
                  omnibusContainer.classList.remove('hidden');
                } else {
                  omnibusContainer.classList.add('hidden');
                }
              } else {
                omnibusContainer.classList.add('hidden');
              }
            },
            errorCallback: () => {
              omnibusContainer.classList.add('hidden');
            },
          },
        });
    };
    updateOmnibus();

    initProductForm({
      form,
      callbacks: {
        afterVariantChange: async ({ variant, product }) => {
          updateUrl(variant.id);
          variant.options.forEach((option, index) => {
            const label = sectionContainer.querySelector(
              `label[for="option${index + 1}"] [data-current-value]`,
            );
            if (label) label.innerText = option;
          });
          errorWrapper.classList.remove('shown');

          updateOptions({ variant, product });
          if (omnibusContainer && omnibusValue && variant.sku) {
            omnibusContainer.dataset.sku = variant.sku;
            omnibusContainer.dataset.variantPrice = variant.price;
            updateOmnibus();
          }

          if (wishlistButton) {
            wishlistButton.dataset.wishlistVariantId = variant?.id;
            wishlistButton.dataset.wishlistPrice = formatPrice({
              value: variant?.price ?? 0,
            });
            wishlistButton.dataset.wishlistCompareAtPrice =
              variant?.compare_at_price
                ? formatPrice({ value: variant?.compare_at_price })
                : '';

            const wishlist = await getWishlist();
            const wishlistProduct = wishlist?.listcontents?.find(
              (addedProduct) =>
                addedProduct.epi == variant.id &&
                addedProduct.empi == product.id,
            );
            wishlistButton.dataset.wishlistStatus = wishlistProduct
              ? 'active'
              : 'inactive';
          }
        },
        beforeSubmit: () => {
          if (submit) submit.classList.add('loading');
        },
        afterSubmit: async () => {
          await openMinicart(true);
          if (submit) submit.classList.remove('loading');
          const random = Math.floor(Math.random() * 1000);
          $('#engravingUniqueId').val(random);
          $('#uniqueId').val(random);
        },
        errorCallback: (err) => {
          if (submit) submit.classList.remove('loading');
          if (errorWrapper && errorMessage && err?.data?.message) {
            errorMessage.innerText = err.data.message;
            requestAnimationFrame(() => {
              errorWrapper.classList.add('shown');
              setTimeout(() => {
                errorWrapper.classList.remove('shown');
              }, 3000);
            });
          }
        },
      },
    });
  }

  if (wishlistButton) {
    const toggleLoading = throttle(() => {
      wishlistButton.classList.toggle('loading');
    }, 500);
    wishlistButton.addEventListener('click', async (e) => {
      e.preventDefault();
      toggleLoading();
      const variantID = wishlistButton?.dataset?.wishlistVariantId;
      const masterID = wishlistButton?.dataset?.wishlistProductId;
      const productURL = wishlistButton?.dataset?.wishlistProductUrl;
      const price = wishlistButton?.dataset?.wishlistPrice;
      const compareAtPrice = wishlistButton?.dataset?.wishlistCompareAtPrice;

      if (wishlistButton?.dataset?.wishlistStatus === 'active') {
        await deleteFromWishlist({ variantID, masterID, productURL });
        wishlistButton.dataset.wishlistStatus = 'inactive';
      } else {
        await addToWishlist({
          variantID,
          masterID,
          productURL,
          compareAtPrice,
          price,
        });
        wishlistButton.dataset.wishlistStatus = 'active';
      }
      toggleLoading();
    });
  }
};

execOnLoad(window.dAgency.initProductPage, '.product-page__section');
